import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { IProperty } from './interface';
import { PaginatedResponse, Response } from '../genericInterface';

export const propertyApi = createApi({
  reducerPath: 'propertyApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['properties'],
  endpoints: (builder) => ({
    addProperty: builder.mutation<Response<IProperty>, FormData>({
      query: (payload) => ({
        url: '/real-estate/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['properties']
    }),
    editProperty: builder.mutation<Response<IProperty>, FormData>({
      query: (payload) => ({
        url: `/real-estate/edit`,
        method: 'PATCH',
        body: payload
      }),
      invalidatesTags: ['properties']
    }),
    deleteProperty: builder.mutation<Response<null>, string>({
      query: (payload) => ({
        url: `/real-estate/delete/${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['properties']
    }),
    getAllProperties: builder.query<
      PaginatedResponse<IProperty>,
      string | void
    >({
      query: (query) => ({
        url: `/real-estate/fetch-many?${query}`,
        method: 'GET'
      }),
      providesTags: ['properties']
    }),
    getOneProperties: builder.query<Response<IProperty>, string>({
      query: (payload) => ({
        url: `/real-estate/fetch-one/${payload}`,
        method: 'GET'
      }),
      providesTags: (result, err, arg) => [{ type: 'properties', id: arg }]
    })
  })
});

export const {
  useAddPropertyMutation,
  useDeletePropertyMutation,
  useEditPropertyMutation,
  useGetAllPropertiesQuery,
  useGetOnePropertiesQuery
} = propertyApi;
